import { useState, useEffect } from "react";
import { getLoggedinUser } from "../helpers/api_helper";

const useProfile = () => {
  const userProfileSession = getLoggedinUser();

  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const user = localStorage.getItem('matvuser'); // Retrieve email
    if (user) {
      setUserProfile({ email: user });
      setLoading(false);
    } else {
      setUserProfile(null);
      setLoading(false);
    }
  }, []);

  return { userProfile, loading };

};

export { useProfile };
